import { render } from "./BodySectionCollapse.vue?vue&type=template&id=43cea0c6&scoped=true"
import script from "./BodySectionCollapse.vue?vue&type=script&lang=js"
export * from "./BodySectionCollapse.vue?vue&type=script&lang=js"

import "./BodySectionCollapse.vue?vue&type=style&index=0&id=43cea0c6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4207129294/src/github.com/Tippie-de/frontend-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43cea0c6"]])

export default __exports__